import React, { useState, useEffect, useRef } from 'react';
import "./Products.css";
import { Col, Row, Container } from 'react-bootstrap';
import { Device } from '../../../../Components';
import { Autocomplete, TextField } from '@mui/material';
import axios from "axios";
import { toast } from 'react-toastify';
import { Paginations } from "../../../../Components";
import Skeleton from "react-loading-skeleton";
import { Title } from '../../../../Components'


function Debounce(value, delay) {

    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}



const Products = ({ url, data, handleSidebar, tree, compareList, brandData, brandSelected,
    setCompareList, removeFromList, searchQuery,
    filtersData, addNode, updateNode, removeNode, setTree, selectedItems, setSelectedItems, filtersLoading }) => {
        const [selectedOption, setSelectedOption] = useState(null);
        const [loading, setLoading] = useState(true);
        const [productsData, setData] = useState([]);
        const [totalPages, setTotalPages] = useState(1);
        const [currentPage, setCurrentPage] = useState(1);
        const debouncedSearchQuery = Debounce(searchQuery, 500);
        const [delayedLoading, setDelayedLoading] = useState(true);
        const [topFilters, setTopFilters] = useState({});
        const isInitialMount = useRef(true);
        const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992);
    
        useEffect(() => {
            const handleResize = () => setIsSmallScreen(window.innerWidth < 992);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);
    
        useEffect(() => {
            setData(data?.content?.objects ?? []);
            setTotalPages(data?.content?.pagination?.metadata?.total_pages ?? 1);
            setCurrentPage(data?.content?.pagination?.metadata?.current_page ?? 1);
            setLoading(false);
        }, [data]);
    
        useEffect(() => {
            if (!filtersLoading) {
                const timer = setTimeout(() => setDelayedLoading(false), 200);
                return () => clearTimeout(timer);
            }
        }, [filtersLoading]);
    
        useEffect(() => {
            const fieldDetails = processData(filtersData);
            setTopFilters(fieldDetails);
        }, [filtersData]);
    
        useEffect(() => {
            if (isInitialMount.current) {
                isInitialMount.current = false;
                return;
            }
            fetchData(1);
            setCurrentPage(1);
        }, [brandSelected, debouncedSearchQuery, tree]);
    
        const fetchData = async (pageNumber = 1) => {
            setLoading(true);
            try {
                const start = (pageNumber - 1) * 12;
                const body = {
                    item_group: "Tracking Devices",
                    start,
                    limit: 12,
                    ...(debouncedSearchQuery && { search: encodeURIComponent(debouncedSearchQuery) }),
                    ...(tree.specifications && { specifications: tree.specifications }),
                    ...(tree.features && { features: tree.features }),
                    ...(brandSelected?.length && { brands: brandSelected })
                };
    
                const response = await axios.post(`${url}/api/method/webshop.webshop.doctype.website_item.website_item.items`, body);
                if (response.data.status_code !== 200) throw new Error();
    
                const result = response.data.result;
                setData(result.objects ?? []);
                setTotalPages(result.pagination.metadata.total_pages);
                setCurrentPage(result.pagination.metadata.current_page);
            } catch (error) {
                toast.error("Failed to fetch data. Please try again.");
            } finally {
                setLoading(false);
            }
        };
    
        const onPageChange = (pageNumb) => {
            fetchData(pageNumb);
        };


    const extractFieldDetails = (data, parentPath = []) => {
        let results = [];

        // Ensure data is an object
        if (!data || typeof data !== "object") {
            console.error("Invalid data passed to extractFieldDetails:", data);
            return results;
        }

        // Iterate over the keys of the object
        Object.keys(data).forEach((key) => {
            const value = data[key];

            if (typeof value === "object" && value !== null) {
                // Check if the current item is a group
                const isGroup = value.is_group === 1 || value.field_is_group === 1;

                // Append the current key to the parent path
                const currentPath = isGroup
                    ? [...parentPath, { key, value: 1 }]
                    : [...parentPath];

                if (value.show_filter_in_top === 1 && value.field_name && value.values) {
                    // Add the field_name to the path
                    const fullPath = [...currentPath];

                    results.push({
                        field_name: value.field_name,
                        values: value.values,
                        path: fullPath,
                    });
                }

                // Recursively process nested objects without converting arrays to strings
                results = results.concat(extractFieldDetails(value, currentPath));
            }
        });

        return results;
    };



    const processData = (data) => {
        if (!data || typeof data !== "object") {
            console.error("Invalid data passed to processData:", data);
            return [];
        }
        const specifications = extractFieldDetails(data.specifications, [{ key: "specifications" }]);
        const features = extractFieldDetails(data.features, [{ key: "features" }]);
        return [...specifications, ...features];
    };


    const handleAddNode = (path, nodeData) => {
        const newTree = { ...tree };
        addNode(newTree, path, nodeData);
        setTree(newTree);
    };

    const handleUpdateNode = (path, nodeData, nodeName) => {
        const newTree = { ...tree };
        updateNode(newTree, path, nodeData, nodeName);
        setTree(newTree);
    };

    const handleRemoveNode = (path) => {
        const newTree = { ...tree };
        removeNode(newTree, path);
        setTree(newTree);
    };


    return (
        <>
            <div className='products-content-container'>
                {
                    topFilters && Object.keys(topFilters).length > 0 || isSmallScreen &&(
                        <div className='products-filters-container'>
                        <div className='products-filters'>
                            {
                                delayedLoading ? <>
    
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <Col>
                                            <Skeleton className='filters-auto-complete' count={1} width={150} height={20} />
                                            <Skeleton className='filters-auto-complete' count={1} width={50} height={20} style={{ marginBottom: '5px' }} />
                                        </Col>
                                    ))}
    
                                </>
                                    :
                                    <>
                                        {Object.keys(topFilters).map((key, index, array) => {
                                            const filter = topFilters[key];
                                            const isLastItem = index === array.length - 1;
                                            return (
                                                <Autocomplete
                                                    key={key}
                                                    disablePortal
                                                    value={selectedItems && selectedItems[filter.field_name] && selectedItems[filter.field_name].length > 0 ? selectedItems[filter.field_name][0] : null}
                                                    className={`filters-auto-complete ${isLastItem ? 'after-none' : ''}`}
                                                    options={filter.values || []}
                                                    getOptionLabel={(option) => `${option}`}
                                                    renderOption={(props, option) => (
                                                        <li {...props}>{option}</li>
                                                    )}
                                                    sx={{
                                                        width: 230,
                                                        '& .MuiAutocomplete-paper': {
                                                            boxShadow: 'none',
                                                            border: 'none',
                                                        },
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                border: 'none',
                                                            },
                                                        },
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
    
                                                            {...params}
                                                            label={filter.field_name || "Filter"}
                                                            placeholder={`Select ${filter.field_name || "Option"}`}
                                                            InputLabelProps={{
                                                                className: 'filters-label',
                                                                shrink: true,
                                                            }}
                                                        />
                                                    )}
                                                    onChange={(event, newValue) => {
                                                        setSelectedItems((prev) => {
                                                            const currentOptions = prev[filter.field_name] || [];
                                                            const fullPath = [...filter.path, { key: filter.field_name, value: 0 }];
                                                            const updatedOptions = newValue ? [newValue] : currentOptions.filter((item) => item !== newValue);
                                                            if (newValue) {
                                                                if (currentOptions.length != 0) {
                                                                    handleUpdateNode(fullPath, { is_group: 0, operation: "or", values: updatedOptions }, filter.field_name);
                                                                }
                                                                else {
                                                                    handleAddNode(fullPath, { is_group: 0, operation: "or", values: updatedOptions });
                                                                }
                                                            }
    
                                                            if (updatedOptions.length === 0 || newValue === null) {
                                                                handleRemoveNode(fullPath);
                                                                const { [filter.field_name]: _, ...rest } = prev;
                                                                return rest;
                                                            }
    
                                                            return {
                                                                ...prev,
                                                                [filter.field_name]: updatedOptions,
                                                            };
                                                        });
                                                    }}
                                                />
                                            );
                                        })}
                                    </>
                            }
    
    
                            <div className='show-sidebar' onClick={handleSidebar}>
                                <h1 className='show-sideba-title'>Filters</h1>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    version="1.1"
                                    width="256"
                                    height="256"
                                    viewBox="0 0 256 256"
                                    xmlSpace="preserve"
                                >
                                    <g
                                        style={{
                                            stroke: 'none',
                                            strokeWidth: 0,
                                            strokeDasharray: 'none',
                                            strokeLinecap: 'butt',
                                            strokeLinejoin: 'miter',
                                            strokeMiterlimit: 10,
                                            fill: 'none',
                                            fillRule: 'nonzero',
                                            opacity: 1,
                                        }}
                                        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                                    >
                                        <path
                                            d="M 15.898 90 c -1.657 0 -3 -1.343 -3 -3 V 54.88 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 V 87 C 18.898 88.657 17.555 90 15.898 90 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 74.103 60.069 c -1.657 0 -3 -1.343 -3 -3 V 3 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 v 54.069 C 77.103 58.727 75.76 60.069 74.103 60.069 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 45 90 c -1.657 0 -3 -1.343 -3 -3 V 28.319 c 0 -1.657 1.343 -3 3 -3 c 1.657 0 3 1.343 3 3 V 87 C 48 88.657 46.657 90 45 90 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 45 31.319 c -5.914 0 -10.726 -4.812 -10.726 -10.726 S 39.086 9.868 45 9.868 s 10.726 4.812 10.726 10.726 S 50.914 31.319 45 31.319 z M 45 15.868 c -2.605 0 -4.726 2.12 -4.726 4.726 s 2.12 4.726 4.726 4.726 s 4.726 -2.12 4.726 -4.726 S 47.605 15.868 45 15.868 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 15.898 57.88 c -5.915 0 -10.726 -4.812 -10.726 -10.726 c 0 -5.915 4.812 -10.726 10.726 -10.726 c 5.914 0 10.726 4.812 10.726 10.726 C 26.624 53.068 21.812 57.88 15.898 57.88 z M 15.898 42.428 c -2.606 0 -4.726 2.12 -4.726 4.726 c 0 2.605 2.12 4.726 4.726 4.726 c 2.605 0 4.726 -2.12 4.726 -4.726 C 20.624 44.548 18.503 42.428 15.898 42.428 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 74.103 75.521 c -5.915 0 -10.727 -4.812 -10.727 -10.727 c 0 -5.914 4.812 -10.726 10.727 -10.726 c 5.914 0 10.726 4.812 10.726 10.726 C 84.828 70.71 80.017 75.521 74.103 75.521 z M 74.103 60.069 c -2.606 0 -4.727 2.12 -4.727 4.726 c 0 2.606 2.12 4.727 4.727 4.727 c 2.605 0 4.726 -2.12 4.726 -4.727 C 78.828 62.189 76.708 60.069 74.103 60.069 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 15.898 42.428 c -1.657 0 -3 -1.343 -3 -3 V 3 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 v 36.428 C 18.898 41.085 17.555 42.428 15.898 42.428 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 45 15.868 c -1.657 0 -3 -1.343 -3 -3 V 3 c 0 -1.657 1.343 -3 3 -3 c 1.657 0 3 1.343 3 3 v 9.868 C 48 14.524 46.657 15.868 45 15.868 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                        <path
                                            d="M 74.103 90 c -1.657 0 -3 -1.343 -3 -3 V 72.521 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 V 87 C 77.103 88.657 75.76 90 74.103 90 z"
                                            style={{
                                                stroke: 'none',
                                                strokeWidth: 1,
                                                strokeDasharray: 'none',
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'miter',
                                                strokeMiterlimit: 10,
                                                fill: 'rgb(0,0,0)',
                                                fillRule: 'nonzero',
                                                opacity: 1,
                                            }}
                                        />
                                    </g>
                                </svg>
                            </div>
                        </div>
                        </div>
                    )
                }
             

                <div className='products-content-title'>Tracking Devices</div>

                <Row className='products-row'>
                    {
                        loading ? <>
                            {Array.from({ length: 12 }).map((_, index) => (

                                <Col xl={3} lg={4} md={4} sm={6} xs={12} className='product-col'>

                                    <div key={index} >
                                        <Skeleton className="device-container" animation="wave" variant="rectangular" />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" width="60%" />
                                    </div>
                                </Col>
                            ))}

                        </>
                            : <>
                                {(productsData && productsData.length == 0) ?
                                    <div className='no-data'>
                                        <Title
                                            overlay={"Data"}
                                            title={"No Data Found"}
                                        />
                                    </div>
                                    : <>
                                        {productsData && productsData.map((item, index) => (
                                            <Col xl={3} lg={4} md={4} sm={6} xs={12} key={index} className='product-col'>
                                                <a href={`/productdetails?item_name=${item.name}`}>
                                                    <Device
                                                        url={url}
                                                        company={item.brand_image}
                                                        image={item.website_image}
                                                        name={item.name}
                                                        website_name={item.web_item_name}
                                                        properties={item.properties}
                                                        type={item.item_group}
                                                        isNew={item.isNew}
                                                        short_description={item.short_description}
                                                        compareList={compareList}
                                                        setCompareList={setCompareList}
                                                        removeFromList={removeFromList}
                                                    />
                                                </a>

                                            </Col>
                                        ))}
                                    </>
                                }


                            </>
                    }
                    <div className="d-flex justify-content-center mt-5">
                        <Paginations
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={onPageChange}
                        />
                    </div>
                </Row>


            </div>

        </>
    )
}

export default Products;
